import { DietsContainer } from './views/diets/DietsContainer'
export default DietsContainer
